$(document).ready(function(){
//     PRODUCT VIDEO SLIDER 
    
    $('#product-video-slider').slick({
      dots: false,
      slidesToShow: 4,
      autoplay: false,
      infinite: true,
      arrows: true,
      prevArrow: $('#vr-video-slider__prev-arrow'),
      nextArrow: $('#vr-video-slider__next-arrow'),
      responsive: [
        {
          breakpoint:1200,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint:767,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
		{
          breakpoint:500,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }          
      ]
    });

// PRODUCT VIDEO ON-CLICK PLAY

    $(".video-play-button, .video-slide").click(function(){
      if (  $(this).closest(".video-wrapper").find('video').get(0).paused) {
          $(this).closest(".video-wrapper").find('video').get(0).play();
          $(this).closest(".video-wrapper").find(".video-play-button").css("display", "none");
        $(this).closest(".video-wrapper").find('video').prop('muted', false);
    }
    else {
            
           $(this).closest(".video-wrapper").find('video').get(0).pause();
           $(this).closest(".video-wrapper").find(".video-play-button").css("display", "block");
           $(this).closest(".video-wrapper").find('video').prop('muted', true);
        }

    
    });

     $('.video-slide').focusout(function() {
              $(this).closest(".video-wrapper").find('video').get(0).pause();
           $(this).closest(".video-wrapper").find(".video-play-button").css("display", "block");
  });
});